import { Dispatch } from '@reduxjs/toolkit';
import { GetTurnPortfoliosFromPath } from '../../services/api/GenericClient';
import { TurnPortfolioResource } from '../../types/TurnPortfolioResource';

type Action = {
  readonly type: string;
  readonly payload?: any;
};

export const setTurnPortfolios =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(TurnPortfolioLoading());
      const path = '/turn';
      const response = await GetTurnPortfoliosFromPath<TurnPortfolioResource>(path);

      if (!response) {
        dispatch(TurnPortfolioLoaded([]));
      }

      if (response) {
        dispatch(TurnPortfolioLoaded(response));
      }
    } catch (err) {
      dispatch(TurnPortfolioError());
    }
  };

export const TurnPortfolioLoading = (): Action => ({
  type: TurnActionType.TURN_PORTFOLIO_LOADING as TurnActionType.TURN_PORTFOLIO_LOADING,
});

export const TurnPortfolioLoaded = (payload: TurnPortfolioResource[]): Action => ({
  type: TurnActionType.TURN_PORTFOLIO_LOADED as TurnActionType.TURN_PORTFOLIO_LOADED,
  payload: payload,
});

export const TurnPortfolioError = (): Action => ({
  type: TurnActionType.TURN_PORTFOLIO_ERROR as TurnActionType.TURN_PORTFOLIO_ERROR,
});

export const TurnPortfolioRemove = (): Action => ({
  type: TurnActionType.TURN_PORTFOLIO_REMOVE as TurnActionType.TURN_PORTFOLIO_REMOVE,
});

export enum TurnActionType {
  TURN_PORTFOLIO_LOADING = '[TURN_PORTFOLIO] Turn Portfolios Loading',
  TURN_PORTFOLIO_LOADED = '[TURN_PORTFOLIO] Turn Portfolios Loaded',
  TURN_PORTFOLIO_ERROR = '[TURN_PORTFOLIO] Turn Portfolios Error',
  TURN_PORTFOLIO_REMOVE = '[TURN_PORTFOLIO] Turn Portfolios Clear Redux',
}

export type TurnPortfolioActions = ReturnType<
  | typeof TurnPortfolioLoading
  | typeof TurnPortfolioLoaded
  | typeof TurnPortfolioError
  | typeof TurnPortfolioRemove
>;
